"use client";

import { useContactUs } from "@/hooks/main-hook";
import { useLocale, useTranslations } from "next-intl";
import { useForm } from "react-hook-form";

export default function SendMsg() {
  const t = useTranslations("Home");

  const locale = useLocale();

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  }: any = useForm({ mode: "all" });

  const { mutate, isPending } = useContactUs();

  const onSubmit = (data: any) => {
    mutate(data, {
      onSuccess: () => {
        reset();
      },
    });
  };

  return (
    <section>
      <div
        style={{
          backgroundImage: `url('/shutterstock_660324757 1.png')`,
        }}
        className="min-h-150 bg-cover bg-center bg-no-repeat flex justify-end items-center w-full mt-10 rounded-2xl mb-14 py-6"
      >
        <div className="bg-white/85 backdrop-blur-sm max-w-130 w-full rounded-2xl p-8 md:p-10 shadow-lg md:mr-24 mx-6 ">
          <h2 className="text-2xl md:text-3xl font-bold mb-6 text-center text-main">
            {t("sendMsg")}
          </h2>

          <form
            onSubmit={handleSubmit(onSubmit)}
            className="flex flex-col gap-4"
          >
            <div className="space-y-1">
              <input
                type="text"
                placeholder={t("name")}
                className="border border-gray-300 rounded-lg p-3 w-full focus:outline-none focus:ring-2 focus:ring-main text-gray-700"
                {...register("name", { required: "errorName" })}
              />
              {errors.name && (
                <span className="text-red-500 text-sm">
                  {t(errors.name.message) as any}
                </span>
              )}
            </div>

            {/* Email */}
            <div className="space-y-1">
              <input
                type="email"
                placeholder={t("email")}
                className="border border-gray-300 rounded-lg p-3 w-full focus:outline-none focus:ring-2 focus:ring-main text-gray-700"
                {...register("email", {
                  required: "errorEmail",
                  pattern: {
                    value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                    message: "invalidEmail",
                  },
                })}
              />
              {errors.email && (
                <span className="text-red-500 text-sm">
                  {t(errors.email.message) as any}
                </span>
              )}
            </div>

            {/* Subject */}
            <div className="space-y-1">
              <input
                type="text"
                placeholder={t("subject")}
                className="border border-gray-300 rounded-lg p-3 w-full focus:outline-none focus:ring-2 focus:ring-main text-gray-700"
                {...register("subject", { required: "errorSubject" })}
              />
              {errors.subject && (
                <span className="text-red-500 text-sm">
                  {t(errors.subject.message) as string}
                </span>
              )}
            </div>

            {/* Message */}
            <div className="space-y-1">
              <textarea
                placeholder={t("message")}
                className="border border-gray-300 rounded-lg p-3 w-full h-28 resize-none focus:outline-none focus:ring-2 focus:ring-main text-gray-700"
                {...register("message", { required: "errorMessage" })}
              ></textarea>
              {errors.message && (
                <span className="text-red-500 text-sm">
                  {t(errors.message.message) as string}
                </span>
              )}
            </div>

            {/* Submit Button */}
            <button
              type="submit"
              className="bg-main text-white py-3 rounded-lg font-semibold hover:bg-main/90 transition duration-200 w-full disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer"
              disabled={isPending}
            >
              {locale === "ar" ? "إرسال الرسالة" : "Send Message"}
            </button>
          </form>
        </div>
      </div>
    </section>
  );
}
